import { useState, useEffect, useCallback } from 'react';
import Button from '../../../components/Button';
import { formFieldClass, formShell } from '../../../styles/formShell';

const LabelForm = ({ onSubmit, initialData, onCancel, isDuplicateLabel }) => {
    const [name, setName] = useState('');
    const [color, setColor] = useState('#cccccc');
    const [error, setError] = useState('');

    useEffect(() => {
        if (initialData) {
            setName(initialData.name);
            setColor(initialData.color);
        } else {
            setName('');
            setColor('#cccccc');
        }
        setError('');
    }, [initialData]);

    const handleSubmit = useCallback(async (e) => {
        e.preventDefault();

        if (!name.trim()) {
            setError('ラベル名は必須です');
            return;
        }

        if (name.trim().length > 50) {
            setError('ラベル名は50文字以内で入力してください');
            return;
        }

        if (isDuplicateLabel && isDuplicateLabel(name, initialData?.id)) {
            setError('同じ名前のラベルが既に存在します');
            return;
        }

        setError('');
        const success = await onSubmit({ name: name.trim(), color });

        if (success && !initialData) {
            setName('');
            setColor('#cccccc');
        }
    }, [name, color, initialData, onSubmit, isDuplicateLabel]);

    const handleNameChange = useCallback((e) => {
        setName(e.target.value);
        if (error) setError('');
    }, [error]);

    const handleColorChange = useCallback((e) => {
        setColor(e.target.value);
    }, []);

    const handleCancel = useCallback(() => {
        setName('');
        setColor('#cccccc');
        setError('');
        onCancel();
    }, [onCancel]);

    return (
        <form onSubmit={handleSubmit} className={`${formShell.form} gap-3`}>
            <div className={formShell.formRow}>
                <div className={`${formShell.group} min-w-0 flex-1`}>
                    <label htmlFor="label-name" className={formShell.label}>
                        ラベル名
                    </label>
                    <input
                        id="label-name"
                        className={formFieldClass(Boolean(error))}
                        type="text"
                        value={name}
                        placeholder="例：避難所、高台 など"
                        onChange={handleNameChange}
                        maxLength={50}
                    />
                </div>

                <div className={formShell.group}>
                    <label htmlFor="label-color" className={`${formShell.label} inline-flex items-center gap-1`}>
                        <span className="material-symbols-outlined text-icon-control">palette</span>
                        色
                    </label>
                    <input
                        id="label-color"
                        className={formShell.colorPicker}
                        type="color"
                        value={color}
                        onChange={handleColorChange}
                        title="ラベルの色を選択"
                    />
                </div>
            </div>

            <div className="min-h-[1.75rem]">
                {error && <p className={formShell.error}>{error}</p>}
            </div>

            <div className={formShell.actionsInline}>
                <Button
                    variant="secondary"
                    type="button"
                    size="cta"
                    onClick={handleCancel}
                   
                >
                    キャンセル
                </Button>
                <Button
                    variant="primary"
                    type="submit"
                    size="cta"
                    disabled={!name.trim()}
                   
                >
                    {initialData ? '更新' : '追加'}
                </Button>
            </div>
        </form>
    );
};

export default LabelForm;
